import { shallowRef } from "@vue/reactivity";
import { watchEffect } from "@vue/runtime-core";
import { useWindow } from "./use-window";

export const useIsTablet = (customBreakpoint?: number) => {
    const windowCtx = useWindow();
    const calcIsTablet = () => windowCtx.w.value.matchMedia(`(max-width: ${customBreakpoint ?? 1099}px)`);
    const isTablet = shallowRef(calcIsTablet());

    watchEffect(() => {
        isTablet.value = calcIsTablet();
    });

    return { isTablet };
};